var _toConsumableArray = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/asyncToGenerator");

// SQLite3_DDL
//
// All of the SQLite3 specific DDL helpers for renaming/dropping
// columns and changing datatypes.
// -------
var Bluebird = require('bluebird');

var _require = require('lodash'),
    assign = _require.assign,
    uniqueId = _require.uniqueId,
    find = _require.find,
    identity = _require.identity,
    map = _require.map,
    omit = _require.omit,
    invert = _require.invert,
    fromPairs = _require.fromPairs; // So altering the schema in SQLite3 is a major pain.
// We have our own object to deal with the renaming and altering the types
// for sqlite3 things.


function SQLite3_DDL(client, tableCompiler, pragma, connection) {
  this.client = client;
  this.tableCompiler = tableCompiler;
  this.pragma = pragma;
  this.tableNameRaw = this.tableCompiler.tableNameRaw;
  this.alteredName = uniqueId('_knex_temp_alter');
  this.connection = connection;
  this.formatter = client && client.config && client.config.wrapIdentifier ? client.config.wrapIdentifier : function (value) {
    return value;
  };
}

assign(SQLite3_DDL.prototype, {
  tableName: function tableName() {
    return this.formatter(this.tableNameRaw, function (value) {
      return value;
    });
  },
  getColumn: function () {
    var _getColumn = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(column) {
      var _this = this;

      var currentCol;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentCol = find(this.pragma, function (col) {
                return _this.client.wrapIdentifier(col.name) === _this.client.wrapIdentifier(column);
              });

              if (currentCol) {
                _context.next = 3;
                break;
              }

              throw new Error("The column ".concat(column, " is not in the ").concat(this.tableName(), " table"));

            case 3:
              return _context.abrupt("return", currentCol);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getColumn(_x) {
      return _getColumn.apply(this, arguments);
    }

    return getColumn;
  }(),
  getTableSql: function getTableSql() {
    var _this2 = this;

    this.trx.disableProcessing();
    return this.trx.raw("SELECT name, sql FROM sqlite_master WHERE type=\"table\" AND name=\"".concat(this.tableName(), "\"")).then(function (result) {
      _this2.trx.enableProcessing();

      return result;
    });
  },
  renameTable: function () {
    var _renameTable = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.trx.raw("ALTER TABLE \"".concat(this.tableName(), "\" RENAME TO \"").concat(this.alteredName, "\"")));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function renameTable() {
      return _renameTable.apply(this, arguments);
    }

    return renameTable;
  }(),
  dropOriginal: function dropOriginal() {
    return this.trx.raw("DROP TABLE \"".concat(this.tableName(), "\""));
  },
  dropTempTable: function dropTempTable() {
    return this.trx.raw("DROP TABLE \"".concat(this.alteredName, "\""));
  },
  copyData: function copyData() {
    return this.trx.raw("SELECT * FROM \"".concat(this.tableName(), "\"")).bind(this).then(this.insertChunked(20, this.alteredName));
  },
  reinsertData: function reinsertData(iterator) {
    return function () {
      return this.trx.raw("SELECT * FROM \"".concat(this.alteredName, "\"")).bind(this).then(this.insertChunked(20, this.tableName(), iterator));
    };
  },
  insertChunked: function insertChunked(amount, target, iterator) {
    iterator = iterator || identity;
    return function (result) {
      var batch = [];
      var ddl = this;
      return Bluebird.reduce(result, function (memo, row) {
        memo++;
        batch.push(row);

        if (memo % 20 === 0 || memo === result.length) {
          return ddl.trx.queryBuilder().table(target).insert(map(batch, iterator)).then(function () {
            batch = [];
          }).then(function () {
            return memo;
          });
        }

        return memo;
      }, 0);
    };
  },
  createTempTable: function createTempTable(createTable) {
    return function () {
      return this.trx.raw(createTable.sql.replace(this.tableName(), this.alteredName));
    };
  },
  _doReplace: function _doReplace(sql, from, to) {
    var oneLineSql = sql.replace(/\s+/g, ' ');
    var matched = oneLineSql.match(/^CREATE TABLE (\S+) \((.*)\)/);
    var tableName = matched[1];
    var defs = matched[2];

    if (!defs) {
      throw new Error('No column definitions in this statement!');
    }

    var parens = 0,
        args = [],
        ptr = 0;
    var i = 0;
    var x = defs.length;

    for (i = 0; i < x; i++) {
      switch (defs[i]) {
        case '(':
          parens++;
          break;

        case ')':
          parens--;
          break;

        case ',':
          if (parens === 0) {
            args.push(defs.slice(ptr, i));
            ptr = i + 1;
          }

          break;

        case ' ':
          if (ptr === i) {
            ptr = i + 1;
          }

          break;
      }
    }

    args.push(defs.slice(ptr, i));
    var fromIdentifier = from.replace(/[`"]/g, '');
    args = args.map(function (item) {
      var split = item.trim().split(' ');
      var normalizedFrom = from; // Backwards compatible for double quoted sqlite databases
      // The "from" and "to" field use backsticks, because this is the default notation for
      // SQlite3 since Knex 0.14.
      // e.g. from: `about`
      //
      // We have to replace the from+to field with double slashes in case you created your SQlite3
      // database with Knex < 0.14.

      if (item.match("\"".concat(fromIdentifier, "\""))) {
        normalizedFrom = "\"".concat(fromIdentifier, "\"");
      } else if (item.match("`".concat(fromIdentifier, "`"))) {
        normalizedFrom = "`".concat(fromIdentifier, "`");
      }

      if (split[0] === normalizedFrom) {
        // column definition
        if (to) {
          split[0] = to;
          return split.join(' ');
        }

        return ''; // for deletions
      } // skip constraint name


      var idx = /constraint/i.test(split[0]) ? 2 : 0; // primary key and unique constraints have one or more
      // columns from this table listed between (); replace
      // one if it matches

      if (/primary|unique/i.test(split[idx])) {
        return item.replace(/\(.*\)/, function (columns) {
          return columns.replace(normalizedFrom, to);
        });
      } // foreign keys have one or more columns from this table
      // listed between (); replace one if it matches
      // foreign keys also have a 'references' clause
      // which may reference THIS table; if it does, replace
      // column references in that too!


      if (/foreign/.test(split[idx])) {
        split = item.split(/ references /i); // the quoted column names save us from having to do anything
        // other than a straight replace here

        split[0] = split[0].replace(normalizedFrom, to);

        if (split[1].slice(0, tableName.length) === tableName) {
          split[1] = split[1].replace(/\(.*\)/, function (columns) {
            return columns.replace(normalizedFrom, to);
          });
        }

        return split.join(' references ');
      }

      return item;
    });
    return oneLineSql.replace(/\(.*\)/, function () {
      return "(".concat(args.join(', '), ")");
    }).replace(/,\s*([,)])/, '$1');
  },
  // Boy, this is quite a method.
  renameColumn: function () {
    var _renameColumn = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(from, to) {
      var _this3 = this;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.client.transaction(
              /*#__PURE__*/
              function () {
                var _ref = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee3(trx) {
                  var column, sql, a, b, createTable, newSql, _invert, mappedFrom, mappedTo;

                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _this3.trx = trx;
                          _context3.next = 3;
                          return _this3.getColumn(from);

                        case 3:
                          column = _context3.sent;
                          _context3.next = 6;
                          return _this3.getTableSql(column);

                        case 6:
                          sql = _context3.sent;
                          a = _this3.client.wrapIdentifier(from);
                          b = _this3.client.wrapIdentifier(to);
                          createTable = sql[0];
                          newSql = _this3._doReplace(createTable.sql, a, b);

                          if (!(sql === newSql)) {
                            _context3.next = 13;
                            break;
                          }

                          throw new Error('Unable to find the column to change');

                        case 13:
                          _invert = invert(_this3.client.postProcessResponse(invert({
                            from: from,
                            to: to
                          }))), mappedFrom = _invert.from, mappedTo = _invert.to;
                          return _context3.abrupt("return", Bluebird.bind(_this3).then(_this3.createTempTable(createTable)).then(_this3.copyData).then(_this3.dropOriginal).then(function () {
                            return this.trx.raw(newSql);
                          }).then(_this3.reinsertData(function (row) {
                            row[mappedTo] = row[mappedFrom];
                            return omit(row, mappedFrom);
                          })).then(_this3.dropTempTable));

                        case 15:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x4) {
                  return _ref.apply(this, arguments);
                };
              }(), {
                connection: this.connection
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function renameColumn(_x2, _x3) {
      return _renameColumn.apply(this, arguments);
    }

    return renameColumn;
  }(),
  dropColumn: function () {
    var _dropColumn = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5(columns) {
      var _this4 = this;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.client.transaction(function (trx) {
                _this4.trx = trx;
                return Bluebird.all(columns.map(function (column) {
                  return _this4.getColumn(column);
                })).bind(_this4).then(_this4.getTableSql).then(function (sql) {
                  var _this5 = this;

                  var createTable = sql[0];
                  var newSql = createTable.sql;
                  columns.forEach(function (column) {
                    var a = _this5.client.wrapIdentifier(column);

                    newSql = _this5._doReplace(newSql, a, '');
                  });

                  if (sql === newSql) {
                    throw new Error('Unable to find the column to change');
                  }

                  var mappedColumns = Object.keys(this.client.postProcessResponse(fromPairs(columns.map(function (column) {
                    return [column, column];
                  }))));
                  return Bluebird.bind(this).then(this.createTempTable(createTable)).then(this.copyData).then(this.dropOriginal).then(function () {
                    return this.trx.raw(newSql);
                  }).then(this.reinsertData(function (row) {
                    return omit.apply(void 0, [row].concat(_toConsumableArray(mappedColumns)));
                  })).then(this.dropTempTable);
                });
              }, {
                connection: this.connection
              }));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function dropColumn(_x5) {
      return _dropColumn.apply(this, arguments);
    }

    return dropColumn;
  }()
});
module.exports = SQLite3_DDL;